import { render, staticRenderFns } from "./stockPopup.vue?vue&type=template&id=2a0a7a6d&scoped=true"
import script from "./stockPopup.vue?vue&type=script&lang=js"
export * from "./stockPopup.vue?vue&type=script&lang=js"
import style0 from "./stockPopup.vue?vue&type=style&index=0&id=2a0a7a6d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0a7a6d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a0a7a6d')) {
      api.createRecord('2a0a7a6d', component.options)
    } else {
      api.reload('2a0a7a6d', component.options)
    }
    module.hot.accept("./stockPopup.vue?vue&type=template&id=2a0a7a6d&scoped=true", function () {
      api.rerender('2a0a7a6d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mechanism/components/myDealChild/child/stockPopup.vue"
export default component.exports